import { toast, ToastOptions } from 'react-toastify';

const defaultOptions: ToastOptions = {
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    className: 'custom-toast',
};

export const showSuccessToastFullScreen = (message: string, delay: number = 3000) => {
    defaultOptions.autoClose = delay;
    defaultOptions.position = 'top-center';

    toast.success(message, defaultOptions);
};

export const showErrorToastFullScreen = (message: string, delay: number = 3000) => {
    defaultOptions.position = 'top-center';
    defaultOptions.autoClose = delay;
    toast.error(message, defaultOptions);
};

export const showErrorToastApp = (message: string, delay: number = 3000) => {
    defaultOptions.position = 'top-right';
    defaultOptions.autoClose = delay;
    toast.error(message, defaultOptions);
};